"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var CarlsbergHeadlessError = /** @class */function (_super) {
  __extends(CarlsbergHeadlessError, _super);
  function CarlsbergHeadlessError(error) {
    var _a, _b, _c, _d, _e;
    var _this = _super.call(this, error.message) || this;
    _this.name = (_a = error.name) !== null && _a !== void 0 ? _a : 'Unknown Carlsberg Headless Error';
    _this.message = error.message;
    _this.status = (_b = error.status) !== null && _b !== void 0 ? _b : 500;
    // extra metadata for CarlsbergHeadlessError
    _this.url = (_c = error.url) !== null && _c !== void 0 ? _c : undefined;
    _this.locale = (_d = error.locale) !== null && _d !== void 0 ? _d : undefined;
    _this.code = (_e = error.code) !== null && _e !== void 0 ? _e : undefined;
    _this.originalError = JSON.stringify(error);
    Error.captureStackTrace(_this, CarlsbergHeadlessError);
    return _this;
  }
  CarlsbergHeadlessError.prototype.formatForCI = function () {
    return "\n" + this.name + "\n" + this.message + "\nstatus: " + this.status + "\nurl: " + this.url + "\nlocale: " + this.locale + "\ncode: " + this.code + "\noriginal error: " + this.originalError + "\n    ";
  };
  return CarlsbergHeadlessError;
}(Error);
exports.default = CarlsbergHeadlessError;